import { render } from "./SubscribeSection.vue?vue&type=template&id=2b4af17a"
import script from "./SubscribeSection.vue?vue&type=script&lang=js"
export * from "./SubscribeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__